import { render, staticRenderFns } from "./materialCategoryLeaderList.vue?vue&type=template&id=72045248&scoped=true"
import script from "./materialCategoryLeaderList.vue?vue&type=script&lang=js"
export * from "./materialCategoryLeaderList.vue?vue&type=script&lang=js"
import style0 from "./materialCategoryLeaderList.vue?vue&type=style&index=0&id=72045248&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72045248",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72045248')) {
      api.createRecord('72045248', component.options)
    } else {
      api.reload('72045248', component.options)
    }
    module.hot.accept("./materialCategoryLeaderList.vue?vue&type=template&id=72045248&scoped=true", function () {
      api.rerender('72045248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/system/materialCategoryLeaderList.vue"
export default component.exports